/**
	TY NPS component. Include ty-nps.js and ty-rating-2.css in your page. 
	Usage:

		$('#overallrating').tyNPS({
			maxValue: 10,
			minValue: 0,
			readOnly: false,
			npsMsgs: {
				leastLikely: '@Extremely unlikely to recommend',
				mostLikely: '@Extremely likely to recommend'
			},
		 	selectedCallback: 
		 		function(selectedRating) {
					if (selectedRating) {
						window.alert('selected!');
					} else {
						window.alert('unselected!');
					}
				}				
		});
 */

(function($){
 
	var defaultSettings = {
		minValue: 0,
		maxValue: 10,
		initValue: null,
		selectedCallback: $.noop,
		readOnly: false,
		npsMsgs: {
			leastLikely: '@Extremely unlikely to recommend',
			mostLikely: '@Extremely likely to recommend'
		},
		ratingNumbers: {
			'0': 'zero',
			'1': 'one',
			'2': 'two',
			'3': 'three',
			'4': 'four',
			'5': 'five',
			'6': 'six',
			'7': 'seven',
			'8': 'eight',
			'9': 'nine',
			'10': 'ten'
		},
		numbersDict:{
			zero: '0',
			one:'1',
			two: '2',
			three: '3',
			four: '4',
			five: '5',
			six: '6',
			seven: '7',
			eight: '8',
			nine: '9',
			ten: '10'
		}		
	};

	var getRatingSentiment = function(rating, componentColors) {

		if(rating && componentColors && componentColors[rating]) {
			return 'rating-' + componentColors[rating];
		}

		// We replace maxValue and minValue because NPS colors should be always for 0 to 10
		var minValue = 0, maxValue = 10,
			span = maxValue - minValue,
			rating = rating + minValue;
		
		if (rating <= Math.ceil(span * 3 / 5)) {
			return 'rating-neg';
		} else if (rating > maxValue - Math.ceil(span * 1 / 5)) {
			return 'rating-pos';
		} else {
			return 'rating-neu';
		}
	};

	var generateContent = function(element, settings, leastLikely, mostLikely) {
		
		element.empty();

		var content = $('<div></div>').addClass('rating rating-nps').attr('data-scale', settings.maxValue);
		element.append(content);

		var rating = $('<ul></ul>').addClass('rating-buttons');

		for (var currValue = settings.minValue; currValue <= settings.maxValue; currValue++) {
			rating.append(
				$('<li></li>').attr('data-value', currValue).html(settings.numbersDict[settings.ratingNumbers[String(currValue)]])
			);
		}
		content.append(rating);

		content.append(
			$('<div></div>').addClass('rating-label rating-label-min').html(leastLikely)
		);

		content.append(
			$('<div></div>').addClass('rating-label rating-label-max').html(mostLikely)
		);
	};
	
	function activateContent(element, initValue, minValue, maxValue, readOnly, componentColors, selectedCallback) {
		
		var selectedRating = null;
		
		if (!readOnly) {
			element.find('li').mouseover(function() {
				var selectedValue = $(this).data('value');
				activateHoverColoring(selectedValue, componentColors);
			});
			element.find('li').click(selectCurrRating);
			element.mouseleave(function() {
				renderSelectedRating(componentColors);
			});
		}
		
		if (initValue != null) {
			selectRating(initValue);
		}
		
		function selectCurrRating() {
			var currRating = $(this).data('value');
			selectRating(currRating);
		}
	
		function selectRating(newRating) {
	
			// read value including clean up possibility		
			element.find('li').removeClass('is-selected');
			if (newRating == selectedRating) {
				selectedRating = null;
			} else {
				selectedRating = newRating;
				element.find('[data-value=' + newRating + ']').addClass('is-selected');
			}
			
			// update UI
			renderSelectedRating(componentColors);
			selectedCallback && selectedCallback(selectedRating);
		}

		function activateHoverColoring(selectedValue, componentColors) {
			markRatingAndDescription(selectedValue, componentColors);
		}
		
		function renderSelectedRating() {
			if (selectedRating != null) {
				markRatingAndDescription(selectedRating, componentColors);
			} else {
				cleanRating();
			}
		}
		
		function markRatingAndDescription(rating) {
			markRating(element, rating, minValue, maxValue, componentColors);
		}
	
		function cleanRating() {
			element.find('li').removeClass('is-active');
			element.find('.rating').removeClass('rating-neg rating-pos rating-neu');
			element.find('.rating-label-min, .rating-label-max').removeClass('is-active');
		}
		
		function markRating(element, rating, minValue, maxValue, componentColors) {

			cleanRating();
						
			var ratingInt = parseInt(rating);
			
			for (var i = minValue; i <= ratingInt; i++) {
				element.find('[data-value=' + i + ']').addClass('is-active');
			}

			if (ratingInt === minValue) {
				element.find('.rating-label-min').addClass('is-active');
			} else if (ratingInt === maxValue) {
				element.find('.rating-label-max').addClass('is-active');
			}

			element.find('.rating').addClass(
				getRatingSentiment(rating, componentColors)
			);
		}
	}	
		 
	$.fn.extend({
		
		/**
		 * Creates rating component on current DOM element. See the plugin docu 
		 * above for settings object documention.
		 */
		tyNPS: function(settings) {
			
			var settings = $.extend({}, defaultSettings, settings);
		    var replaced = settings.npsMsgs.leastLikely.split(/\s+/).join('</span><span>');
		    if (replaced != settings.npsMsgs.leastLikely) settings.npsMsgs.leastLikely = '<span>' + replaced + '</span>';

		    var replaced = settings.npsMsgs.mostLikely.split(/\s+/).join('</span><span>');
		    if (replaced != settings.npsMsgs.mostLikely) settings.npsMsgs.mostLikely = '<span>' + replaced + '</span>';

			return this.each(function() {
				var currElement = $(this);
				generateContent(currElement, settings, settings.npsMsgs.leastLikely, settings.npsMsgs.mostLikely);
				activateContent(currElement, settings.initValue, 
					settings.minValue, settings.maxValue, 
					settings.readOnly, settings.componentColors, settings.selectedCallback);
			});
		}
	});

})(jQuery);
